import logo from "../../shared/assets/Vector.svg";
import { themeAtom } from "../../shared/atoms";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

interface Props {}

export const TechFormRequestsListHeader: React.FC<Props> = () => {
  const theme = useAtomValue(themeAtom);

  return (
    <div className="flex justify-start gap-4">
      <div>
        <img src={logo} alt="Description" className="mr-2" />
      </div>

      <div className="flex h-12 flex-col items-start justify-start gap-1 self-stretch">
        <div className="inline-flex items-start justify-start gap-5 self-stretch">
          <div className="flex items-center justify-start gap-4">
            <div
              className={twMerge(
                "font-['Be Vietnam Pro'] text-lg font-bold leading-[30px]",
                theme.home.tailwind.textDefault,
              )}
            >
              Requests
            </div>
          </div>
        </div>
        <div className="inline-flex items-start justify-start gap-2 self-stretch">
          <div
            className={twMerge(
              "font-['Be Vietnam Pro'] shrink grow basis-0 text-[12px] font-normal leading-[13.75px]",
              theme.home.tailwind.textDefault,
            )}
          >
            Address pending requests efficiently and review the ones submitted.
          </div>
        </div>
      </div>
    </div>
  );
};
